import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { WELLNESS_CHECK_IN_ENTRY_POINTS_TYPE } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/mixpanelConstants'
import {
  WellnessCheckInParsedResults,
  WellnessCheckInResponse,
} from '@lyrahealth-inc/shared-app-logic/src/features/wellnessCheckIn/types'
import { WELLNESS_CHECK_IN_INITIAL_VALUES } from '@lyrahealth-inc/shared-app-logic/src/features/wellnessCheckIn/wellnessCheckInMetadata'

import {
  CLEAR_WELLNESS_CHECK_IN_ENTRY_POINT,
  CLEAR_WELLNESS_CHECK_IN_FORM_VALUES,
  CLEAR_WELLNESS_CHECK_IN_RESULTS,
  GET_WELLNESS_CHECK_IN_RESULTS_DATA_fulfilled,
  SET_SHOULD_SAVE_WELLNESS_CHECK_IN_POST_LOGIN,
  SET_WELLNESS_CHECK_IN_ENTRY_POINT,
  SET_WELLNESS_CHECK_IN_FORM_VALUES,
  SET_WELLNESS_CHECK_IN_RESULTS,
} from './wellnessCheckInActions'

const initialState = fromJS({
  wellnessCheckInResults: {},
})

export default createReducer(initialState, {
  [SET_WELLNESS_CHECK_IN_ENTRY_POINT]: ($$state: $TSFixMe, action: { data: WELLNESS_CHECK_IN_ENTRY_POINTS_TYPE }) => {
    $$state = $$state.set('wellnessCheckInEntryPoint', action.data)
    return $$state
  },
  [CLEAR_WELLNESS_CHECK_IN_ENTRY_POINT]: ($$state: $TSFixMe) => {
    $$state = $$state.set('wellnessCheckInEntryPoint', undefined)
    return $$state
  },
  [SET_WELLNESS_CHECK_IN_FORM_VALUES]: ($$state: $TSFixMe, action: { data: object }) => {
    $$state = $$state.set('wellnessCheckInFormValues', action.data)
    return $$state
  },
  [CLEAR_WELLNESS_CHECK_IN_FORM_VALUES]: ($$state: $TSFixMe) => {
    $$state = $$state.set('wellnessCheckInFormValues', WELLNESS_CHECK_IN_INITIAL_VALUES)
    return $$state
  },
  [SET_WELLNESS_CHECK_IN_RESULTS]: ($$state: $TSFixMe, action: { data: WellnessCheckInParsedResults }) => {
    $$state = $$state.set('wellnessCheckInParsedResults', action.data)
    return $$state
  },
  [CLEAR_WELLNESS_CHECK_IN_RESULTS]: ($$state: $TSFixMe) => {
    $$state = $$state.set('wellnessCheckInResultsList', undefined)
    $$state = $$state.set('wellnessCheckInParsedResults', {})
    return $$state
  },
  [SET_SHOULD_SAVE_WELLNESS_CHECK_IN_POST_LOGIN]: ($$state: $TSFixMe, action: { data: boolean }) => {
    $$state = $$state.set('shouldSaveWellnessCheckInPostLogin', action.data)
    return $$state
  },
  [GET_WELLNESS_CHECK_IN_RESULTS_DATA_fulfilled]: (
    $$state: $TSFixMe,
    action: { payload: WellnessCheckInResponse[] },
  ) => {
    $$state = $$state.set('wellnessCheckInResultsList', action.payload)
    return $$state
  },
})
